import { NgModule } from '@angular/core';
import { VideosModalComponent } from './videos-modal.component';
import { TinymceModule } from 'angular2-tinymce';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BaseModule } from '../../../shared/base.module';

@NgModule({
    imports: [
        MatSlideToggleModule,
        BaseModule,
        ModalModule.forRoot(),
        TinymceModule.withConfig({
            menubar: false,
            elementpath: false,
            keep_styles: false,
            invalid_elements : 'small,em',
            invalid_styles : 'text-small',
        }),

    ],
    exports: [VideosModalComponent],
    declarations: [VideosModalComponent],
    providers: [],
})

export class VideosModalModule {
}
